/**
 * Section for edge-to-edge lists. Rows provide their own padding.
 * Same as Section with card padding stripped.
 */
import { Section, type SectionProps } from "./section";

export type ListSectionProps = Omit<
    SectionProps,
    "sectionClassName" | "sectionContentClassName"
>;

export function ListSection(props: ListSectionProps) {
    return (
        <Section
            {...props}
            sectionClassName="p-0"
            sectionContentClassName="p-0"
        />
    );
}
